import GitHubCalendar from "react-github-calendar";
import styles from "./github.module.css";

export const GithubStats = () => {
    return (
        <div className={styles.container}>
            <h1 className={styles.heading}>Activities 📈</h1>
            <div className={styles.GitHubCalendar}>
            <div
                data-aos="fade-right"
                data-aos-delay="30"
                data-aos-duration="1500"
                data-aos-easing="ease-in-out-cubic"

            >
                <GitHubCalendar class="react-activity-calendar" username="Mehul-Kanjariya" />
            </div>
            </div>
            <div className={styles.githubStats}>
                <img id="github-stats-card"
                    src="https://github-readme-stats.vercel.app/api?username=Mehul-Kanjariya&show_icons=true&theme=tokyonight&border_radius=10"
                    alt="Mehul"
                />
                <img id="github-streak-stats"
                    src="https://github-readme-streak-stats.herokuapp.com/?user=Mehul-Kanjariya&theme=tokyonight&border_radius=10"
                    alt="Mehul"
                />
            </div>
            <div>
            <img className={styles.lang} id="github-top-langs"
                    src="https://github-readme-stats.vercel.app/api/top-langs/?username=Mehul-Kanjariya&&theme=tokyonight&border_radius=10"
                    alt="Mehul"
                />
            </div>
        </div>
    );
};